import { AreaPropinas } from "../Pagos.types"

type DiffResult = {
    creados: AreaPropinas[]
    modificados: AreaPropinas[]
    eliminados: AreaPropinas[]
}

export const getDiffItems = (
    original: AreaPropinas[],
    modificado: AreaPropinas[]
): DiffResult => {
    const originalMap = new Map(
        original.map(item => [item.hotel_puesto_propina_id, item])
    )

    const modificadoMap = new Map(
        modificado.map(item => [item.hotel_puesto_propina_id, item])
    )

    const creados: AreaPropinas[] = []
    const modificados: AreaPropinas[] = []
    const eliminados: AreaPropinas[] = []

    // Creados y modificados
    for (const item of modificado) {
        const originalItem = originalMap.get(item.hotel_puesto_propina_id)

        if (!originalItem) {
            creados.push(item)
            continue
        }

        const cambio =
            originalItem.area !== item.area ||
            originalItem.porcentaje !== item.porcentaje ||
            originalItem.puesto_id !== item.puesto_id

        if (cambio) {
            modificados.push(item)
        }
    }

    // Eliminados
    for (const item of original) {
        if (!modificadoMap.has(item.hotel_puesto_propina_id)) {
            eliminados.push(item)
        }
    }

    return {
        creados,
        modificados,
        eliminados,
    }
}